import React from 'react'

export default function Home() {
    return (
        <div>
            <h1>¡Ya queda poco!</h1>
        </div>
    )
}